import { showDeveloperError } from 'src/helpers/env';

export const errorResponseHandler = (error) => (
    Promise.reject({...error})
        .catch(function(error) {
            showDeveloperError(error);
            throw error;
        })
);
